<template>
  <div>
    基本信息
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
